export const CartDiscountMixin = {
  /**
   * Агрегируем данные об акциях из ответа.
   * @param {Object} resp
   * @returns {{sum: number, discounts: Array}} массив акций и сумма скидки
   */
  getDiscountData: function (resp) {
    // Типы скидок
    let discountTypes = ['_volume_discount', '_wholesale', '_gifts_discount', '_3_price_2_discount', 'large_family'],
      discountData = {
        sum: 0,
        discounts: [],
      },
      discounts
    discountTypes.forEach(type => {
      if (resp[type] && resp[type].discounts) {
        discountData.sum += resp[type].sum
        discounts = resp[type].discounts.map(discount => {
          discount.type = type
          return discount
        })
        discountData.discounts = discountData.discounts.concat(discounts)
      }
    })
    const threeByTwoDiscountSum = resp['_3_price_2_discount']
    if (threeByTwoDiscountSum) {
      discountData.threeByTwoDiscountSum = threeByTwoDiscountSum.sum
    }
    return discountData
  },
}
